import { formatUtils } from "@/utils";

export const calculateTendance = (
  newValue: number,
  oldValue: number,
  locale: string = "fr"
) => {
  if (oldValue === 0 || !oldValue)
    return { value: "", isPositive: false, hide: true };
  const res = (newValue - oldValue) / oldValue;
  const sign = res >= 0 ? "+" : "-";

  return {
    value: `${sign} ${formatUtils.formatToPercent(Math.abs(res), 1, locale)}`,
    isPositive: sign === "+",
    hide: Math.abs(res * 100) >= 1000,
  };
};
